import React from "react";
import { observer } from "mobx-react";
import { PageLayout } from "../../../../common/layout";
import { useRootStore } from "../../../../store/contexts";
import { MusicalGenreView } from "./MusicalGenreView";
import { MusicalGenreViewStore } from "../../store/MusicalGenreViewStore";
import { useStore } from "../../../../hooks";

export const MusicalGenreViewPage = observer(() => {
  const rootStore = useRootStore();
  const { router } = rootStore;

  const id = router.params?.id as string;
  const path = `/musicalGenre/view/${id}`;

  const store = useStore(
    path,
    () => {
      const s = new MusicalGenreViewStore(rootStore);
      return s;
    },
    { id }
  );

  return (
    <div>
      <PageLayout
        navigationElements={{
          links: [],
          onNavigatedTo: (id) => {
            store.setCardState(id, true);
          },
        }}
      >
        <MusicalGenreView musicalGenreViewStore={store} />
      </PageLayout>
    </div>
  );
});
